<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      clip-rule="evenodd"
      d="M13.4083 12.8984L17.2911 16.7743C17.6816 17.1649 17.6816 17.798 17.2911 18.1886C16.9006 18.5791 16.2674 18.5791 15.8769 18.1886L11.9954 14.3138L8.11943 18.1965C7.72891 18.587 7.09574 18.587 6.70522 18.1965C6.31469 17.806 6.31469 17.1728 6.70522 16.7823L10.5799 12.9008L6.69728 9.02498C6.30676 8.63446 6.30676 8.00129 6.69728 7.61077C7.08781 7.22025 7.72097 7.22025 8.1115 7.61077L11.9929 11.4854L15.8688 7.60271C16.2593 7.21218 16.8925 7.21218 17.283 7.60271C17.6735 7.99323 17.6735 8.6264 17.283 9.01692L13.4083 12.8984Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
